import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_CLIENT_ODOO_LOADING = 'GET_CLIENT_ODOO_LOADING';
export const GET_CLIENT_ODOO_SUCCESS = 'GET_CLIENT_ODOO_SUCCESS';
export const GET_CLIENT_ODOO_REJECT = 'GET_CLIENT_ODOO_REJECT';

//* ACTIONS ------------------------------------------------
export const getClientOdooLoading = () => ({ type: GET_CLIENT_ODOO_LOADING });
export const getClientOdooSuccess = (payload) => ({ type: GET_CLIENT_ODOO_SUCCESS, payload });
export const getClientOdooReject = (payload) => ({ type: GET_CLIENT_ODOO_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getClientOdooRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Clients/web/GetClientsOdoo`, options);
};
